import "./keyInfoItem.less";

const KeyInfoItem = ({ value, title, showTitle }) => {
   if (title === "-" || title === null || title === "") return null;

   return (
      <div className="gx-product-body-keyInfo">
         <p className="p3">
            {showTitle === true && <b>{title}: </b>}
            {value}
         </p>
      </div>
   );
};

export default KeyInfoItem;
